<section class="beneficio">
    <div class="container">
        <div class="row d-flex justify-content-between align-items-center">
            <div class="col-lg-6 text-left mb-4">
                <h3 class="mb-4">{{ data.TITULO }}</h3>
                <p class="mb-4">{{ data.DESCRICAO }}</p>
            </div>
            <div class="col-lg-5 offset-lg-1 d-flex justify-content-lg-end justify-content-center mb-4">
                <img src="{{ data.IMAGEM }}" class="img-fluid"/>
            </div>
        </div>
    </div>
</section>